export const fonts = {
  heading: "Libre Franklin, sans-serif",
  body: "Libre Franklin, sans-serif",
};
